import clsx from 'clsx';

export default function SkeletonBlock({ className, rounded = 'rounded' }) {
  return (
    <div
      className={clsx(
        'animate-pulse bg-neutral-200 dark:bg-neutral-700',
        rounded,
        className
      )}
    />
  );
}
